import React from "react";
import { ReactComponent as TickBefore } from "../../assets/TickBefore.svg";
import { ReactComponent as TickAfter } from "../../assets/TickAfter.svg";
import "./AINavigation.css"; // Import custom CSS

const AINavigation = ({ navtabs, activeTab, setActiveTab }) => {
  return (
    <div className="ai-navigation-container">
      <div className="ai-navigation-tabs">
        {navtabs?.map((tab, index) => (
          <span
            key={tab.value}
            onClick={() => setActiveTab(tab.value)}
            className={`ai-navigation-tab ${activeTab === tab?.value ? "active" : ""}`}
          >
            {activeTab === tab.value ? <TickAfter className="tick-icon mt-2" /> : <TickBefore className="tick-icon mt-2" />} {/* Tick icons */}
            <span className="tab-label">
            {tab.label}
            </span>
          </span>
        ))}
      </div>
    </div>
  );
};

export default AINavigation;
